import { Message } from '@uigovpe/components';

/** Erro da tela inteira. Erro de campo fica no próprio campo. */
export function ErrorNotice({ message }: { message?: string | null }) {
  if (!message) return null;

  return (
    <div role="alert">
      <Message severity="error" text={message} />
    </div>
  );
}
